import React, { forwardRef } from "react";
import { bool, func, node, object, oneOf, string } from "prop-types";

import componentSizes from "../../constants/componentSizes";
import Field from "../Field";
import TextInput from "./components/TextInput";

const TextField = forwardRef(
  (
    {
      className,
      defaultValue,
      disabled,
      error,
      helper,
      id,
      inputOptions,
      isValid,
      label,
      onChange,
      required,
      size,
      type,
      value,
      ...passThroughProps
    },
    ref
  ) => (
    <Field
      ref={ref}
      className={className}
      error={error}
      helper={helper}
      id={id}
      isValid={isValid}
      label={label}
      {...passThroughProps}
    >
      <TextInput
        defaultValue={defaultValue}
        disabled={disabled}
        isValid={isValid}
        onChange={onChange}
        required={required}
        size={size}
        type={type}
        value={value}
        {...inputOptions}
      />
    </Field>
  )
);

TextField.displayName = "TextField";

TextField.propTypes = {
  className: string,
  // eslint-disable-next-line react/require-default-props
  defaultValue: string,
  disabled: bool,
  error: string,
  helper: node,
  hint: string.isRequired,
  id: string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  inputOptions: object,
  isValid: bool,
  label: string.isRequired,
  onChange: func,
  required: bool,
  size: oneOf([componentSizes.SM, componentSizes.MD, componentSizes.LG]),
  type: oneOf(["email", "number", "text"]),
  // eslint-disable-next-line react/require-default-props
  value: string
};

TextField.defaultProps = {
  className: "",
  disabled: false,
  error: "",
  isValid: true,
  helper: "",
  inputOptions: {},
  onChange: () => {},
  required: false,
  size: componentSizes.MD,
  type: "text"
};

export default TextField;
